import styled from 'styled-components'

interface IVendorTooltipStyledProps {}

export const VendorTooltipStyled = styled.div<IVendorTooltipStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  min-width: ${(props) => props.theme.typography.pxToRem(300)};
`
